import React from 'react';
import ReactDOM from 'react-dom/client';
import $ from 'jquery';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.$ = $;
window.jQuery = $;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();